import styled from 'styled-components';
import ButtonBaseNormal from './Base';

import THEME_CONSTS from '~/consts/theme';

const ButtonSecondaryNormal = styled(ButtonBaseNormal)`
    color: ${THEME_CONSTS.BUTTON_SECONDARY_FONT_COLOR};
    background-color: ${THEME_CONSTS.BUTTON_SECONDARY_BG_COLOR};
`
export default ButtonSecondaryNormal;